import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
const faqs = [{
  q: '¿El material es digital?',
  a: 'Sí, es 100% digital. Podés leerlo desde tu celular, tablet o computadora, o imprimirlo si preferís.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Una vez confirmado el pago, te llega un mail automático con el link para descargar la guía y todos los bonos al instante.'
}, {
  q: '¿Sirve desde recién nacido?',
  a: '¡Sí! Incluye actividades y consejos adaptados desde los primeros días de vida hasta los 3 años.'
}, {
  q: '¿Necesito materiales especiales?',
  a: 'No. Todas las actividades están pensadas para hacerse con cosas que ya tenés en casa o con tu propio cuerpo y voz.'
}, {
  q: '¿Por cuánto tiempo tengo acceso?',
  a: 'El acceso es de por vida. Lo descargás y te queda para siempre para consultarlo cuando quieras.'
}, {
  q: '¿Qué pasa después de comprar?',
  a: 'Te llega el acceso por mail y ya podés empezar a leer y aplicar las ideas hoy mismo.'
}, {
  q: '¿Las actividades llevan mucho tiempo?',
  a: 'Para nada. Están pensadas para mamás reales. Con 10 o 15 minutos al día, o integrándolas en la rutina (como el baño o el cambio de pañal), es suficiente.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="bg-cream" data-id="element-75">
      <Section className="max-w-3xl" data-id="element-76">
        <SectionTitle data-id="element-77">Preguntas frecuentes</SectionTitle>

        <div className="mt-12 space-y-4" data-id="element-78">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-beige-muted rounded-xl overflow-hidden transition-all duration-200" data-id="element-79">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-80">
                <span className="font-bold text-charcoal pr-8" data-id="element-81">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sage-dark flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-82" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-83">
                <p className="text-charcoal-light" data-id="element-84">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </Section>
    </div>;
}